//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import WarehouseListView from '@/views/Warehouse/WhWarehouse/list'
import WarehouseProductsView from '@/views/Warehouse/WhWarehouse/products'

//
export default {
    path: 'warehouses',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'warehouse',
            component: WarehouseListView,
        },
        {
            path: 'products',
            name: 'warehouse-products',
            component: WarehouseProductsView,
            meta: {
                title: 'Productos por bodega',
            },
        },
    ],
    meta: {
        title: 'Bodegas',
    },
}
